var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeafIconGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "6ale92us7a",
    d: "M0 0h21v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8xv111bekc",
    d: "M0 0h21v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(9 2.503 31.807)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u3rmq1910b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6ale92us7a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.028 9.23C9.09 13.382 4.676 17.312 3.441 24c4.8-3.35 11.15-4.144 14.514-8.194C21.427 11.628 20.81 5.85 21 0c-4.04 1.92-8.042 2.983-12.137 3.924-7.836 1.8-11.151 10.328-7.177 18.254C6.09 14.216 9.284 10.75 14.03 9.231z",
    fill: "#0E4816",
    mask: "url(#u3rmq1910b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.495)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3l15sqp3nd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8xv111bekc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.028 9.23C9.09 13.382 4.676 17.312 3.441 24c4.8-3.35 11.15-4.144 14.514-8.194C21.427 11.628 20.81 5.85 21 0c-4.04 1.92-8.042 2.983-12.137 3.924-7.836 1.8-11.151 10.328-7.177 18.254C6.09 14.216 9.284 10.75 14.03 9.231z",
    fill: "#589D62",
    mask: "url(#3l15sqp3nd)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafIconGreen);
export default __webpack_public_path__ + "static/media/leaf-icon-green.baccced112c2396be5159a50836697c0.svg";
export { ForwardRef as ReactComponent };